export default __webpack_public_path__ + "static/media/about-us-image.f687ae3b.jpg";